<div class="tooltip__container" (click)="isMobile ? openTooltipModal() : ''">
  <span [class]="'tooltip__text tooltip__text--container ' + tooltipPosition">
    <ng-content></ng-content>
  </span>
  <div class="tooltip-label-container">
    <div class="tooltip-icon-container">
      <i *ngIf="icon" [class]="'fa ' + icon"></i>
    </div>
    <span>
      <ng-content select="[label]"></ng-content>
    </span>
  </div>
</div>
